import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-151dc824"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "tree-body"
};
const _hoisted_2 = {
  class: "tree-body"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "tree-img",
  src: "https://sct-ieds-test.oss-cn-shenzhen.aliyuncs.com/file/1685592609666.png",
  alt: ""
}, null, -1));
const _hoisted_4 = {
  class: "tree-content"
};
const _hoisted_5 = {
  class: "content-left"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "tree-title"
}, "产业生态树", -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "tree-subtitle"
}, "10秒构建产业数据生态展示化", -1));
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "tree-details"
}, "帮助产业链生态大树创作者快速实现从表格数据源到生态大树的制作和展示", -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content-right"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: "https://sct-ieds-test.oss-cn-shenzhen.aliyuncs.com/file/1685592609888.png",
  alt: ""
})], -1));
import { defineComponent } from "vue";
const __default__ = defineComponent({
  name: "treeView"
});
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {
    const id = ref(1);
    const route = useRoute();
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_hoisted_6, _hoisted_7, _hoisted_8, _createElementVNode("div", {
        class: "tree-btn",
        onClick: _cache[0] || (_cache[0] = $event => _ctx.$router.push({
          name: 'businessTree',
          query: {
            code: 'default001'
          }
        }))
      }, " 立即体验 ")]), _hoisted_9])])]);
    };
  }
});